import React from 'react';
import { Outlet } from 'react-router-dom';
import DomainSelectorFragment from '@app/site/secured/_common/layout/fragment/DomainSelectorFragment';
import UserMenuItemFragment from '@app/site/secured/_common/layout/fragment/UserMenuItemFragment';
import FooterFragment from '@app/site/secured/_common/layout/fragment/FooterFragment';

const RmsLayout = () => <div className="min-h-full bg-gray-100">
	<nav className="border-b border-gray-200 bg-white">
		<div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
			<div className="flex items-center gap-3">
				<DomainSelectorFragment />
				<img className="hidden h-6 w-auto sm:block" src="/assets/img/brand/rp-logo.svg" alt="RoomPulse" />
			</div>
			<UserMenuItemFragment />
		</div>
	</nav>
	<Outlet />
	<FooterFragment />
</div>;

export default RmsLayout;
